import jsPDF from "jspdf"
import 'jspdf-autotable'
import cabecalho from '@/relatorios/geral/header'

export default {

    Run(item) {

        let header = []
        header.push(cabecalho.run())

        let relatorio = []

        relatorio.push([{ content: item.descricao, colSpan: 2, styles: { halign: 'center', fontSize: 9, fontStyle: 'bold', fillColor: [215, 215, 215] }}])

        relatorio.push(
            [
                { content: item.titulos[0], styles: { halign: 'center', fontSize: 9, fontStyle: 'bold', fillColor: [215, 215, 215] }},
                { content: item.titulos[1], styles: { halign: 'center', fontSize: 9, fontStyle: 'bold', fillColor: [215, 215, 215] }},
            ])

        if(item.itens.length > 0)
        {
            for(let i = 0; i < item.itens.length; i++){

                relatorio.push(
                    [
                        { content: item.itens[i][0], styles: { halign: 'left', fontSize: 9 }},
                        { content: item.itens[i][1], styles: { halign: 'left', fontSize: 9 }},
                    ])
            }
        }

        const doc = new jsPDF()

        //Tabela do cabeçalho
        doc.autoTable({theme: 'plain', body: header, didDrawCell: (data) => {
                if (data.section === 'body' && data.column.index === 0) {
                    var base64Img = cabecalho.logo()
                    doc.addImage(base64Img, 'JPEG', data.cell.x + 3, data.cell.y, 30, 20)
                }
            },})

        //Tabela do corpo
        doc.autoTable({theme: 'grid', body: relatorio })

        doc.output('dataurlnewwindow')
    }
}
